export const load = () => ({
	h1: 'Connect With Our Commercial Team',
	title: 'Connect With Our Commercial Team',
	showTitle: true,
});
